import $ from 'jquery'

export function domready(fn: Function) {
  $(fn)
}
